"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const rxjs_1 = require("rxjs");
const errors_1 = require("@ledgerhq/errors");
const out_1 = require("@elrondnetwork/erdjs/out");
const deviceAccess_1 = require("../../hw/deviceAccess");
const operation_1 = require("../../operation");
const hw_app_elrond_1 = __importDefault(require("./hw-app-elrond"));
const js_buildTransaction_1 = require("./js-buildTransaction");
const constants_1 = require("./constants");
const binary_utils_1 = require("./utils/binary.utils");
const account_1 = require("../../account");
const logic_1 = require("./logic");
function getOptimisticOperationType(transactionMode) {
    switch (transactionMode) {
        case "delegate":
            return "DELEGATE";
        case "unDelegate":
            return "UNDELEGATE";
        case "withdraw":
            return "WITHDRAW_UNBONDED";
        case "claimRewards":
            return "REWARD";
        case "reDelegateRewards":
            return "DELEGATE";
        default:
            return "OUT";
    }
}
function getOptimisticOperationDelegationAmount(transaction) {
    var _a;
    let dataDecoded;
    switch (transaction.mode) {
        case "delegate":
            return transaction.amount;
        case "unDelegate":
            dataDecoded = binary_utils_1.BinaryUtils.base64Decode((_a = transaction.data) !== null && _a !== void 0 ? _a : "");
            return new bignumber_js_1.BigNumber(`0x${dataDecoded.split("@")[1]}`);
        default:
            return new bignumber_js_1.BigNumber(0);
    }
}
const buildOptimisticOperation = (account, transaction, unsignedTx) => {
    const senders = [account.freshAddress];
    const recipients = [transaction.recipient];
    const { subAccountId, fees } = transaction;
    if (!fees) {
        throw new errors_1.FeeNotLoaded();
    }
    const type = getOptimisticOperationType(transaction.mode);
    const tokenAccount = (subAccountId &&
        account.subAccounts &&
        account.subAccounts.find(ta => ta.id === subAccountId)) ||
        null;
    const value = tokenAccount || transaction.mode !== "send"
        ? fees
        : transaction.amount.plus(transaction.fees || new bignumber_js_1.BigNumber(0));
    const delegationAmount = getOptimisticOperationDelegationAmount(transaction);
    const operation = {
        id: (0, operation_1.encodeOperationId)(account.id, "", type),
        hash: "",
        type,
        value,
        fee: fees,
        blockHash: null,
        blockHeight: null,
        senders,
        recipients,
        accountId: account.id,
        transactionSequenceNumber: unsignedTx.nonce,
        date: new Date(),
        contract: new out_1.Address(transaction.recipient).isContractAddress()
            ? transaction.recipient
            : undefined,
        extra: {
            amount: delegationAmount,
        },
    };
    if (tokenAccount && subAccountId) {
        operation.subOperations = [
            {
                id: (0, operation_1.encodeOperationId)(subAccountId, "", "OUT"),
                hash: "",
                type: "OUT",
                value: transaction.amount,
                fee: new bignumber_js_1.BigNumber(0),
                blockHash: null,
                blockHeight: null,
                senders,
                recipients,
                accountId: subAccountId,
                date: new Date(),
                extra: {},
            },
        ];
    }
    return operation;
};
/**
 * Sign Transaction with Ledger hardware
 */
const signOperation = ({ account, deviceId, transaction }) => (0, deviceAccess_1.withDevice)(deviceId)(transport => new rxjs_1.Observable(o => {
    function main() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!transaction.fees) {
                throw new errors_1.FeeNotLoaded();
            }
            // Collect data for an ESDT transfer
            const { subAccounts } = account;
            const { subAccountId } = transaction;
            const tokenAccount = !subAccountId
                ? null
                : subAccounts && subAccounts.find(ta => ta.id === subAccountId);
            const elrond = new hw_app_elrond_1.default(transport);
            yield elrond.setAddress(account.freshAddressPath);
            if (tokenAccount) {
                const { token } = (0, account_1.decodeTokenAccountId)(tokenAccount.id);
                if ((token === null || token === void 0 ? void 0 : token.name) && token.id && token.ledgerSignature) {
                    yield elrond.provideESDTInfo(token.name, (0, logic_1.extractTokenId)(token.id), token === null || token === void 0 ? void 0 : token.units[0].magnitude, constants_1.CHAIN_ID, token.ledgerSignature);
                }
            }
            const unsignedTx = yield (0, js_buildTransaction_1.buildTransactionToSign)(account, transaction);
            o.next({
                type: "device-signature-requested",
            });
            const r = yield elrond.signTransaction(account.freshAddressPath, unsignedTx, true);
            o.next({
                type: "device-signature-granted",
            });
            const parsedUnsignedTx = JSON.parse(unsignedTx);
            const operation = buildOptimisticOperation(account, transaction, parsedUnsignedTx);
            o.next({
                type: "signed",
                signedOperation: {
                    operation,
                    signature: r,
                    rawData: parsedUnsignedTx,
                },
            });
        });
    }
    main().then(() => o.complete(), e => o.error(e));
}));
exports.default = signOperation;
//# sourceMappingURL=js-signOperation.js.map